"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgFacebook = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M8.515 7.847H6v4.105h2.515V24h4.832V11.897h3.371l.357-4.05h-3.728v-2.31c0-.952.192-1.336 1.117-1.336h2.618V0h-3.345C10.14 0 8.522 1.583 8.522 4.612c-.007 2.646-.007 3.235-.007 3.235z" })));
};
exports.default = SvgFacebook;
//# sourceMappingURL=Facebook.js.map